import { render, staticRenderFns } from "./GoogleTrending.vue?vue&type=template&id=596dc0b7&scoped=true"
import script from "./GoogleTrending.vue?vue&type=script&lang=js"
export * from "./GoogleTrending.vue?vue&type=script&lang=js"
import style0 from "./GoogleTrending.vue?vue&type=style&index=0&id=596dc0b7&prod&lang=css"
import style1 from "./GoogleTrending.vue?vue&type=style&index=1&id=596dc0b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596dc0b7",
  null
  
)

export default component.exports